<template>
    <div class="ModalCadastro" >
        <b-modal ref="modal-cadastro" id="modalCadastro" size="xl" :hide-footer="true" :hide-header="true">
            <div class="w-100 text-end txt-size-20 txt-blue-2">
                <span @click="close"><i class="fas fa-times c-pointer"></i></span>
            </div>

            <div class="px-3 pb-3">
                <div class="row">
                    <div class="col-12">
                        <span class="txt-p txt-blue-2 txt-size-25 txt-w-bold mb-2">
                            Cadastro para acesso aos vídeos do Sollicita Capacitação.
                        </span>
                        <p class="txt-p txt-size-16 txt-w-5 txt-grey-2">
                            Preencha os campos abaixo para criar sua conta.
                        </p>
                    </div>
                </div>
            </div>
            

            <Cadastro :resposta="respostaCadastro"></Cadastro>
        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoErro /*,idModulo*/ } from '@/config/global'
    import Cadastro from '@/components/Cadastro'
    import axios from 'axios'

    export default {
        name: 'ModalCadastro',
        components: {
            Cadastro,
        },
        data: function () {
            return {

            }
        },
        props: {
            showModal: Boolean,
        },
        methods: {
            respostaCadastro(user) {
                this.login(user.dsEmail, user.dsSenha);
            },

            login(login, senha) {
                let $this = this;
                axios.post(`${urlApi}/Auth/signin`,
                    {
                        login: login,
                        password: senha,
                        //idModulo: idModulo,
                    }

                )
                    .then(res => {
                        if (res.data.token.authenticated) {
                            res.data.token.usuario = res.data.usuario;
                            $this.$store.commit('setUser', res.data.token)
                            $this.$router.push({ name: 'Home' });
                        } else {
                            avisoErro("Erro ao realizar login.");
                        }
                    })
                    .catch(function () {
                        avisoErro("Erro ao realizar login.");
                    })

            },
                        
            load() {
                
            },

            close() {
                this.$refs['modal-cadastro'].hide();
            },


        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-cadastro'].show();
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Cadastro */
   .form-control {
    }
</style>

